import router from "@/router";
import { isToufang } from "./base";
import { Toast } from 'vant'

export const calcScores = (scores) => {
    return +scores / 10
}

export function getParams() {
    const queryParams = {};
    const queryString = window.location.search.substring(1);
    const params = queryString.split('&');

    params.forEach(param => {
        const [key, value] = param.split('=');
        queryParams[key] = decodeURIComponent(value || '');
    });

    return queryParams;
}

export function getParam(key){
    return getParams()[key];
}

export const setStorage = (key, value) => {
    if(typeof value === "object" && value !== null){
        value = JSON.stringify(value)
    }
    localStorage.setItem(key, value);
}

export const getStorage = (key) => {
    return localStorage.getItem(key)
}

export const removeStorage = (key) => {
    localStorage.removeItem(key)
}

export const clearStorage = () => {
    localStorage.clear();
}

export const calcPrice = (price) => {
    return price / 100
}

export const isFacebookWebView = () => {
  const ua = window.navigator.userAgent;
  const referrer = document.referrer
  return /FB_IAB|FBAN|FBAV|FBWEBVIEW|FBANLITE|Facebook/i.test(ua) || referrer.includes('facebook');
};

export const isTiktokWebView = () => {
    // 方法1：检查用户代理(UA)标识
  const userAgent = navigator.userAgent.toLowerCase();
  const isTikTokUA = /(tiktok)|(musically)|(bytedance)/i.test(userAgent);
  
  // 方法2：检查TikTok特有的JS对象（更可靠）
  const isTikTokEnv = typeof webview !== 'undefined' && 
                     webview?.name === 'TikTok';
  
  // 方法3：检查TikTok特有的URL参数
  const urlParams = new URLSearchParams(window.location.search);
  const hasTikTokParam = urlParams.has('tt_webid') || 
                         urlParams.has('tt_chain_token');
  
  return isTikTokUA || isTikTokEnv || hasTikTokParam;
}

export const isToufangWebView = () => {
    return isFacebookWebView() || isTiktokWebView();
}


export const isAndroid = () => {
    const u = navigator.userAgent;
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    return isAndroid;
}

export const isIos = () => {
    const u = navigator.userAgent;
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    return isiOS;
}


// 随机数
export const getRandomInt = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

export const goToRouter = (path, query = {}) => {
    const obj = {}
    if(isToufangWebView() || getParam('ch')){
        obj.ch = '1'
    }
    const q = router.app.$route.query
    router.app.$router.push({
        path,
        query: {
            ...q,
            ...query,
            ...obj,
            is_succ: 0
        }
    })
}

export const saveImage = async (imgUrl) => {
    return await fetch(imgUrl)
        .then(response => response.blob())
        .then(blob => {
            // 创建一个指向Blob的URL
            var blobUrl = URL.createObjectURL(blob);
            // 创建一个链接元素
            var a = document.createElement('a');
            a.style.display = 'none';
            a.href = blobUrl;
            // 获取文件名
            var fileName = imgUrl.split('/').pop();
            // 设置下载的文件名
            a.download = fileName; // 你可以根据实际情况设置文件名，也可以从原URL中提取
            // 将链接添加到文档中
            document.body.appendChild(a);
            // 触发点击链接
            a.click();
            // 清理：移除链接和释放Blob URL
            document.body.removeChild(a);
            URL.revokeObjectURL(blobUrl);
            Toast('Photo saved!')
        }).catch(() => {
            Toast('Save Failed')
        })
}

// 深克隆
export const deepClone = (arg) => {
  let res = null
  // 判断如果是数组则创建数组
  if (arg instanceof Array) {
    res = []
    // 如果是对象，则创建对象
  } else if (typeof arg === 'object' && arg !== null) {
    res = {}
  }
  for (var attr in arg) {
    // 判断是否为引用类型（array，object） 则需要克隆存入到新的地址
    if (typeof arg[attr] === 'object' && arg[attr] !== null) {
      res[attr] = deepClone(arg[attr])
    } else {
      // 其他类型直接赋值
      res[attr] = arg[attr]
    }
  }
  return res
}
